import { ExportResultCode } from '@opentelemetry/core';
import { JSON_ENCODER } from '@opentelemetry/otlp-transformer/build/src/common/utils';
import { createExportTraceServiceRequest } from '@opentelemetry/otlp-transformer/build/src/trace/internal';
import { sendFaroEvents } from './faroTraceExporter.utils';
export class FaroTraceExporter {
    constructor(config) {
        this.config = config;
    }
    export(spans, resultCallback) {
        const traceEvent = createExportTraceServiceRequest(spans, JSON_ENCODER);
        this.config.api.pushTraces(traceEvent);
        sendFaroEvents(traceEvent.resourceSpans, this.config.api);
        resultCallback({ code: ExportResultCode.SUCCESS });
    }
    shutdown() {
        return Promise.resolve(undefined);
    }
}
